import { createQuery } from '@tanstack/svelte-query'
import { getProjects } from '../api/projects'
import queryClient from '../constants/query-client'

export const useProjects = (params: Record<string, string | number>) => createQuery(() => ({
  queryKey: ['projects', params],
  queryFn: () => getProjects(params),
}), () => queryClient)
